import { render } from "./Accordion.vue?vue&type=template&id=416e02d9"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=416e02d9&lang=scss"
script.render = render

export default script